export default __webpack_public_path__ + "static/media/profile-1.daf9203e.jpg";